export default __webpack_public_path__ + "static/media/YellowPokeball.c1913a51.svg";